import { getAssetImage } from "@/service/image/asset";
import { remediumOrganization } from "@/components/common/structured-data/organization-structured-data";
import {
  contentDates,
  JsonLd,
  paywalledPart,
} from "@/components/common/structured-data/json-ld";

// Poradniki i szybkie pytania.
export const TutorialStructuredData = ({
  tutorial: { seo, createdAt, updatedAt },
  url,
}: {
  tutorial: TutorialVM;
  url: string;
}) => {
  return (
    <JsonLd
      data={{
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": url,
        },
        headline: seo.title,
        publisher: remediumOrganization,
        author: remediumOrganization,
        description: seo.description || undefined,
        image: getAssetImage("/tutorial/header.png"),
        ...contentDates(createdAt, updatedAt),
        ...paywalledPart,
      }}
    />
  );
};
